// 'use strict'
// Template version: 1.3.1
// see http://vuejs-templates.github.io/webpack for documentation.

const path = require('path')

module.exports = {
  dev: {

    // Paths
    assetsRoot: path.resolve(__dirname, '../dist'),
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    proxyTable: {},

    // Various Dev Server settings
    host: '0.0.0.0', // can be overwritten by process.env.HOST
    port: 8085, // can be overwritten by process.env.PORT, if port is in use, a free one will be determined
    autoOpenBrowser: false,
    errorOverlay: true,
    notifyOnErrors: true,
    poll: true, // https://webpack.js.org/configuration/dev-server/#devserver-watchoptions-

    // Use Eslint Loader?
    // If true, your code will be linted during bundling and
    // linting errors and warnings will be shown in the console.
    useEslint: true,
    // If true, eslint errors and warnings will also be shown in the error overlay
    // in the browser.
    showEslintErrorsInOverlay: false,

    /**
     * Source Maps
     */

    // https://webpack.js.org/configuration/devtool/#development
    devtool: 'source-map',

    // If you have problems debugging vue-files in devtools,
    // set this to false - it *may* help
    // https://vue-loader.vuejs.org/en/options.html#cachebusting
    cacheBusting: true,

    cssSourceMap: true
  },

  build: {
    // Template for index.html
    index: path.resolve(__dirname, '../dist/index.html'),

    // Paths
    assetsRoot: path.resolve(__dirname, '../dist'),
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',

    /**
     * Source Maps
     */

    productionSourceMap: true,
    // https://webpack.js.org/configuration/devtool/#production
    devtool: '#source-map',

    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ['js', 'css'],

    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: process.env.npm_config_report
  },

  data: {
    reschedule: 'RESCHEDULE_DATE',
    schedule: 'SCHEDULE_PERIOD',
    delivered: 'DELIVERED',
    restore: 'TO_REVERT',
    collected: 'ON_EXPEDITION',
    incidence: 'INCIDENCE',
    addDriver: 'ADD_DRIVER',
    reportIncidence: 'REPORT_INCIDENCE',
    reportReschedule: 'RESCHEDULE_DATE',
    editRegistration: 'EDIT_REGISTRATION',
    regist: 'VEHICLE_REGISTRATION',
    rescheduleDateTime: 'RESCHEDULE_DATE_TIME',
    showUploadPod: 'SHOW_UPLOAD_POD',
    urlQuery: {
      type: 'reset'
    }
  },

  orderFilters: {
    deliveryDate: 'deliveryDate',
    deliveryPostalCode: 'deliveryPostalCode',
    deliveryPeriodMorning: 'deliveryPeriodMorning',
    deliveryPeriodAfternoon: 'deliveryPeriodAfternoon',
    orderNumber: 'customerOrderCode',
    orderId: 'orderId',
    orderDate: 'orderDate',
    createdAt: 'createdAt',
    deliveryDate: 'deliveryDate',
    availableDate: 'availableDate',
    transport: 'partner',
    confirmedDeliveryDate: 'confirmedDeliveryDate',
    deliveryType: 'deliveryType',
    weight: 'weight',
    volume: 'volume',
    separation: 'stateSeparation',
    validation: 'validation',
    priority: 'priority',
    state: 'stateOrder',
    warehouse: 'warehouse.warehouseName',
    warehouseSection: 'supplier.section.sectionName',
    supplier: 'supplier.supplierName',
    supplierSection: 'supplier.section.sectionName',
    store: 'store.name',
    storeCode: 'storeCode',
    storeName: 'name',
    supplierOrderCode: 'supplierOrderCode',
    mounting: 'mounting',
    createdByChannel: 'createdByChannel',
    volumeTotal: 'volumeTotal',
    effectiveStatus: 'effectiveStatus',
    shippingOriginType: 'shippingOriginType',
    confirmedDeliveryDate: 'confirmedDeliveryDate',
    collectedByPartnerDate: 'collectedByPartnerDate',
    platform: 'platform',
    platformName: 'platformAssociated.platformName',
    name: 'name',
    startPeriod: 'startPeriod',
    schedulingName: 'schedulingName',
    city: 'city',
    postalCode: 'postalCode',
    circuit: 'circuit',
    onlyPlatformName: 'platformName'
  },

  rolesPermissions: [
    {
      role: 'ADMIN',
      type: ['ALL'],
      titleTab: 'tabLabel1',
      activeDriverTab: false,
      activeDropPartner: true,
      menu: {
        showAdmin: true
      }
    },
    {
      role: 'PARTNER',
      type: ['ALL'],
      titleTab: 'tabLabel2',
      activeDriverTab: true,
      activeDropPartner: false,
      menu: {
        showAdmin: true
      }
    },
    {
      role: 'CAR_DEDICATED',
      type: ['ALL'],
      titleTab: 'tabLabel2',
      activeDriverTab: true,
      activeDropPartner: false,
      menu: {
        showAdmin: true
      }
    }
  ],

  datadog: {
    // Lazy require: this file is also require()d by the node-side build
    // scripts (build/build.js -> ../config), which must never load the
    // browser-only ESM runtimeConfig service. Webpack still bundles it.
    get isEnabled () {
      const { getConfig } = require('../src/services/runtimeConfig')
      return Boolean(this.enable && getConfig('VUE_APP_DATADOG_APP_ID'))
    },
    get config () {
      const { getConfig, getRuntimeVersion } = require('../src/services/runtimeConfig')
      return {
        applicationId: getConfig('VUE_APP_DATADOG_APP_ID'),
        clientToken: getConfig('VUE_APP_DATADOG_AUTH_TOKEN'),
        site: getConfig('VUE_APP_DATADOG_SITE'),
        service: getConfig('VUE_APP_DATADOG_PROJECT'),
        forwardErrorsToLogs: true,
        sampleRate: 100,
        trackInteractions: true,
        defaultPrivacyLevel: 'mask-user-input',
        actionNameAttribute: 'data-custom-name',
        env: getConfig('VUE_APP_ENV', process.env.NODE_ENV),
        version: getRuntimeVersion() || getConfig('VUE_APP_ENV_VERSION', process.env.VUE_APP_ENV_VERSION)
      }
    },
    enable: true,
    enableSessions: true
  }
}



//////////////////
// WEBPACK FOOTER
// ./config/index.js
// module id = FhoZ
// module chunks = 1